import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "13",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#004070",
      d: "M11.853 5.414h-.638a.13.13 0 0 0-.127.127v.638c0 .07.057.127.127.127h.637c.07 0 .128-.057.128-.127V5.54a.13.13 0 0 0-.128-.127m.51-1.658H10.45V.378a.13.13 0 0 0-.127-.128H3.565a.13.13 0 0 0-.127.128v3.378H1.525c-.704 0-1.275.57-1.275 1.275v5.228c0 .282.228.51.51.51h2.678v2.104c0 .07.057.127.127.127h6.758c.07 0 .127-.057.127-.127v-2.104h2.678a.51.51 0 0 0 .51-.51V5.03c0-.704-.571-1.275-1.275-1.275M4.52 1.334h4.845v2.422H4.521zm4.845 10.582H4.521V7.518h4.845zm3.188-2.231H10.45V6.434H3.438v3.251H1.334V5.031c0-.105.086-.191.191-.191h10.838c.105 0 .19.086.19.191z"
    }, null, -1)
  ])))
}
export default { render: render }